import { EditAdminNews } from './edit-admin-news';

export default EditAdminNews;
